// modules/anchor-active-nav.js

export default function initAnchorActiveNav(options) {
  var opts = options || {};
  var headerSelector = opts.headerSelector || '#header';
  var linkSelector = opts.linkSelector || '.header__nav a[href^="#"]:not([data-no-spy]), .mobile-menu a[href^="#"]:not([data-no-spy])';
  var activeClass = opts.activeClass || 'is-active';
  var extraOffset = typeof opts.extraOffset === 'number' ? opts.extraOffset : 90;

  var links = [];
  var sections = [];
  var ticking = false;

  function getHeaderOffset() {
    var header = document.querySelector(headerSelector);
    if (!header) return 0;

    return header.offsetHeight || 0;
  }

  function getElementTop(el) {
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var rect = el.getBoundingClientRect();

    return rect.top + scrollY;
  }

  function parseHashTarget(hash) {
    if (!hash || hash.charAt(0) !== '#') return null;

    var raw = hash.slice(1);
    var id = raw.split('?')[0].split('&')[0];

    return id || null;
  }

  function getLinkId(link) {
    return parseHashTarget(link.getAttribute('href'));
  }

  function refresh() {
    links = Array.prototype.slice.call(document.querySelectorAll(linkSelector));

    var ids = links
      .map(function (link) {
        return getLinkId(link);
      })
      .filter(function (id, index, arr) {
        return id && arr.indexOf(id) === index;
      });

    sections = ids
      .map(function (id) {
        var el = document.getElementById(id);

        if (!el) return null;

        return {
          id: id,
          el: el
        };
      })
      .filter(Boolean);

    sections.sort(function (a, b) {
      return getElementTop(a.el) - getElementTop(b.el);
    });

    // console.log('[active-nav] sections:', sections.map(function (section) {
    //   return {
    //     id: section.id,
    //     top: getElementTop(section.el)
    //   };
    // }));
  }

  function setActive(id) {
    links.forEach(function (link) {
      var linkId = getLinkId(link);
      var isActive = id && linkId === id;

      link.classList.toggle(activeClass, isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function getCurrentSectionId() {
    if (!sections.length) return null;

    var headerH = getHeaderOffset();
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var marker = scrollY + headerH + extraOffset;

    var firstTop = getElementTop(sections[0].el);

    if (marker < firstTop) {
      return null;
    }

    var currentId = null;

    sections.forEach(function (section) {
      var top = getElementTop(section.el);

      if (marker >= top) {
        currentId = section.id;
      }
    });

    return currentId;
  }

  function update() {
    ticking = false;

    var id = getCurrentSectionId();

    // console.log('[active-nav] current id:', id);

    setActive(id);
  }

  function requestUpdate() {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(update);
  }

  function setActiveFromHash(hash) {
    var id = parseHashTarget(hash);

    if (id) {
      setActive(id);
    }
  }

  refresh();
  update();

  window.addEventListener('scroll', requestUpdate, { passive: true });

  window.addEventListener('resize', function () {
    refresh();
    requestUpdate();
  });

  return {
    refresh: refresh,
    update: update,
    setActive: setActive,
    setActiveFromHash: setActiveFromHash
  };
}